import { headerHeight } from '../helpers';

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.querySelector('form').addEventListener('submit', (e) =>
      this.onSubmitHandler(e),
    );

    const sortingWrapper = this.querySelector('.facets__sorting');
    const filtersWrapper = this.querySelector('.facets__filters');
    if (sortingWrapper && filtersWrapper) {
      const sortingOpener = sortingWrapper.querySelector(
        '.facets__sorting-opener',
      );
      if (sortingOpener) {
        sortingOpener.addEventListener('click', () => {
          if (sortingWrapper.classList.contains('open')) {
            sortingWrapper.classList.remove('open');
          } else {
            sortingWrapper.classList.add('open');
            filtersWrapper.classList.remove('open');
          }
        });
      }

      const filtersOpener = filtersWrapper.querySelector(
        '.facets__filters-opener',
      );
      if (filtersOpener) {
        filtersOpener.addEventListener('click', () => {
          filtersWrapper.classList.add('open');
          sortingWrapper.classList.remove('open');
          document.querySelector('html').style.overflowY = 'hidden';
        });
      }

      const filtersDrawer = filtersWrapper.querySelector(
        '.facets__filters-drawer',
      );
      if (filtersDrawer) {
        filtersDrawer.style.top = `${headerHeight()}px`;
        filtersDrawer.style.height = `calc(100dvh - ${headerHeight()}px)`;
      }

      const filtersBackdrop = filtersWrapper.querySelector(
        '.facets__filters-backdrop',
      );
      if (filtersBackdrop) {
        filtersBackdrop.style.top = `${headerHeight()}px`;
        filtersBackdrop.style.height = `calc(100dvh - ${headerHeight()}px)`;

        filtersBackdrop.addEventListener('click', () => {
          filtersWrapper.classList.remove('open');
          document.querySelector('html').style.overflowY = '';
        });
      }

      const filtersClose = filtersWrapper.querySelector(
        '.facets__filters-close',
      );
      if (filtersClose) {
        filtersClose.addEventListener('click', () => {
          filtersWrapper.classList.remove('open');
          document.querySelector('html').style.overflowY = '';
        });
      }
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    const sortingWrapper = document.querySelector('.facets__sorting');
    const filtersWrapper = document.querySelector('.facets__filters');
    if (sortingWrapper && filtersWrapper) {
      sortingWrapper.classList.remove('open');
      filtersWrapper.classList.remove('open');
      document.querySelector('html').style.overflowY = '';
    }

    document.getElementById('ProductGridContainer').classList.add('loading');
    const url = `${window.location.pathname}?${searchParams}`;
    const filterDataUrl = (element) => element.url === url;

    FacetFiltersForm.filterData.some(filterDataUrl)
      ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
      : FacetFiltersForm.renderSectionFromFetch(url, event);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.completeRenderPage();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.completeRenderPage();
  }

  static completeRenderPage() {
    const gridContainer = document.getElementById('ProductGridContainer');
    gridContainer.classList.remove('loading');

    if (window.dAgency.proxyLinkSetup)
      window.dAgency.proxyLinkSetup(gridContainer);

    window.endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'click',
      callback: function (requestURL) {
        window.dAgency.ajaxinateCallBack(requestURL);
      },
    });

    const productsTiles = document.querySelectorAll(
      '#CollectionSection .product-tile__container, .search__products .product-tile__container',
    );

    if (typeof window.dAgency.initProductTile !== 'undefined') {
      //let productsOffset = parseInt(productsCounter.innerText);
      for (let index = 0; index < productsTiles.length; index++) {
        const element = productsTiles[index];
        window.dAgency.initProductTile(element);
      }
    }

    document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter',
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    let activeFilters = document.querySelectorAll(
      '.js-filter input[type="checkbox"]:checked',
    ).length;
    if (document.querySelector('[name="filter.v.availability"][value="1"]').checked) {
      activeFilters = activeFilters - 1;
    }
    document
      .querySelectorAll('.facets__active-filters-counter')
      .forEach(
        (activeFiltersCounter) =>
          (activeFiltersCounter.innerText = activeFilters),
      );
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
    );
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const filtersForm = event.target.closest('form');
    if (filtersForm) {
      const sizeFilters = filtersForm.querySelectorAll('input[name="filter.v.option.size"]');
      const availabilityFilter = filtersForm.querySelector('input[name="filter.v.availability"][value="1"]');

      let formData = new FormData(filtersForm);
      let searchParams = new URLSearchParams(formData).toString();
      if (searchParams.includes('filter.v.option.size')) {
        availabilityFilter.checked = true;
      } else {
        availabilityFilter.checked = false;
      }
      formData = new FormData(filtersForm);
      searchParams = new URLSearchParams(formData).toString();
      FacetFiltersForm.renderPage(searchParams, event);
    }

  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this)),
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      if (!event.target.href) return;
      event.preventDefault();
      const facetFiltersForm =
        this.closest('facet-filters-form') ||
        document.querySelector('facet-filters-form');
      if (facetFiltersForm) {
        const form = facetFiltersForm.querySelector('form');
        if (form) {
          form
            .querySelectorAll('input[type="checkbox"]:checked')
            .forEach((checkedFilter) => {
              checkedFilter.checked = false;
            });
          form.querySelector('[type="submit"]').click();
        }
      }
    });
  }
}
customElements.define('facet-remove', FacetRemove);
